export default __webpack_public_path__ + "static/app-store-icon-f1c65687e138a25d086c62d1ff019414.svg";